import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  Input,
  Output,
  DoCheck,
  Component,
  OnDestroy,
  EventEmitter,
  IterableDiffer,
  IterableDiffers,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnFloor } from '@lib/api/entities';
import { SnMenuItemConfig } from '@lib/ui/menu';

@Component({
  selector: 'sn-floor-list',
  templateUrl: './floor-list.component.html',
  styleUrls: ['./floor-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnFloorListComponent implements DoCheck, OnDestroy {
  @Input()
  public floors: SnFloor[] = [];

  @Input()
  public draggableList = false;

  @Input()
  public actions: SnMenuItemConfig<SnFloor>[];

  @Output()
  public readonly focusedFloorChanged = new EventEmitter<SnFloor>();

  @Output()
  public readonly listDropped = new EventEmitter<void>();

  public focusedFloor: SnFloor;

  private readonly floorsDiffer: IterableDiffer<SnFloor>;

  constructor(
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _iterableDiffers: IterableDiffers,
  ) {
    this.floorsDiffer = this._iterableDiffers.find(this.floors).create((index, floor) => floor.id);
  }

  public ngDoCheck(): void {
    const changes = this.floorsDiffer.diff(this.floors);

    if (changes) {
      this._changeDetectorRef.markForCheck();
    }
  }

  public ngOnDestroy(): void {
    this.focusedFloorChanged.complete();
    this.listDropped.complete();
  }

  public trackFloor(index: number, item: SnFloor): any {
    return item.id;
  }

  public onDropped(event: CdkDragDrop<SnFloor>): void {
    moveItemInArray<SnFloor>(this.floors, event.previousIndex, event.currentIndex);
    this.listDropped.next();
  }

  public toggleFloor(floor: SnFloor): void {
    this.focusedFloor = this.focusedFloor && this.focusedFloor.id !== floor.id ? floor : undefined;

    this.focusedFloorChanged.next(this.focusedFloor);
  }
}
